const CANONICAL_ORIGIN = "https://compliguard.com.au";

/**
 * Build a normalized canonical URL for a given pathname.
 * - Always https:// and the non-www apex domain
 * - No trailing slash except for the homepage ("/")
 * - Query strings / hashes are not included (pass pathname only)
 */
export const buildCanonical = (pathname: string): string => {
  const path = pathname || "/";
  if (path === "/") return `${CANONICAL_ORIGIN}/`;
  const trimmed = path.replace(/\/+$/, "");
  return `${CANONICAL_ORIGIN}${trimmed}`;
};
